import _classCallCheck from "/usr/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/usr/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import React from "react";
var __jsx = React.createElement;
import { Component } from "react";
import stl from "./SingleQuest.module.css";
var SingleQuest = /*#__PURE__*/function (_Component) {
  function SingleQuest(props) {
    _classCallCheck(this, SingleQuest);
    return _callSuper(this, SingleQuest, [props]);
  }
  _inherits(SingleQuest, _Component);
  return _createClass(SingleQuest, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        onClick: this.props.onClick,
        className: [stl.singleFaqContainer, this.props.showAns ? stl.expanded : undefined, this.props.faqsPage ? stl.faqsPage : "", stl.StyleMod].join(" ")
      }, /*#__PURE__*/React.createElement("strong", null, this.props.qust), this.props.showAns && /*#__PURE__*/React.createElement("p", null, this.props.ans)));
    }
  }]);
}(Component);
export default SingleQuest;